<template>
  <div class="mx-body tw-mt-8 faq">
    <p>
      For support on using the platform in any particular page, please refer to the tailored user guide at the top right of the page.
    </p>
    <p>Thank you for using the Mentoring Platform.</p>
      <p>If you have any additional questions or concerns, please reach out to our support team at <a href="mailto:mentor@ementoringafrica.or.ke"><strong>mentor@ementoringafrica.or.ke</strong></a><strong>.</strong></p>
  </div>
</template>

<script>
export default {
  name: 'AnyFAQMenteePartial',
};
</script>

<style lang="scss" scoped>
.faq {

  * {
    font-size: 20px;
  }

  h2, h1 {
    font-size: 50px !important;
  }

  p {
    margin-bottom: 20px;
  }

  ol {
    line-height: 1.5;
    list-style-type: decimal;
    color: var(--primary-orange);
  }

  ul {
    list-style-type: disc;
    padding-left: 40px;
  }

  a {
    color: var(--primary-blue);
  }
}
</style>
